<template>
  <div class="row tgju-widgets-row dashboard-widgets-technical-list dash-full-height">
    <div class="col-12">
      <div class="tgju-widget light">
        <div class="list-widget widget-head-page list-row bold list-row-title">
          <div class="list-col l-title head-color">
            <span class="with-icon">
              <i class="uil uil-chart"></i>پروفایل
              {{ title }}
            </span>
          </div>
          
          <div class="list-col l-item pointer hover head-color">
            <router-link :to="{name: 'MarketProfile', params: { name:  $route.params.name }, }" class="l-item-btn-color-blue">
              گزارش روز
            </router-link>
          </div>
          <div class="list-col l-item pointer hover head-color">
            <router-link :to="{name: 'MarketCharts', params: { name:  $route.params.name }, }" class="l-item-btn-color-blue">
              نمودار ها
            </router-link>
          </div>
          <div class="list-col l-item pointer hover head-color">
            <router-link :to="{name: 'MarketArchive', params: { name:  $route.params.name }, }" class="l-item-btn-color-blue">
              آرشیو
            </router-link>
          </div>

          <div class="list-col l-title"></div>

          <div class="list-col l-item pointer hover head-color">
            <a href="" class="l-item-btn-color-blue">
              <div class="fa fa-question-circle l-item-btn-pages"></div>
              راهنما
            </a>
          </div>
        </div>
        <div class="tgju-widget-content full-padding overflow-hidden">
          <MarketArchive></MarketArchive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	// این ویو برای ماژول  بازار  پروفایل شاخص ، بخش آرشیو مورد استفاده قرار میگیرد
	import MarketArchive from "@/components/Market/Profile/Archive";

	export default {
		name: "marketArchive",
		components: {
			MarketArchive,
		},
		data: function () {
			return {
					title: "--",
					symbol: "--"
				};
		},
	};
</script>